var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    deal-picto\n    d-flex\n    align-center\n    justify-center\n\n  ",style:({
    height: _vm.small ? '30px' : '100px'
  })},[(_vm.deal.type === 'delivery')?_c('fa-icon',{attrs:{"icon":"shipping-fast","size":_vm.small ? '2x' : '4x'}}):_vm._e(),(_vm.deal.type === 'deal')?_c('fa-icon',{attrs:{"icon":"gift","size":_vm.small ? '2x' : '4x'}}):_vm._e(),(_vm.deal.type === 'discount')?_c('span',{class:{
      'display-3': !_vm.small,
      'display-1': _vm.small
    }},[_vm._v("-"+_vm._s(_vm.deal.discount))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }